/**
 * Curated public, UK-wide patient resources. These are references to external
 * NHS and professional information, not individual care instructions.
 * Keep Trust-approved local services separate from this national collection.
 * Any change to a destination or meaning requires editorial safety review.
 */
export const WAITING_NATIONAL_RESOURCE_INTRO = Object.freeze({
  heading: 'Trusted information to help you prepare',
  description: 'Prehabilitation means getting support with your physical health and wellbeing before treatment. These national resources explain what you can explore while waiting. Choose the information that is useful to you.',
  firstStep: 'Start here',
  topics: 'Explore a topic',
  providerNote: 'Official NHS information and national perioperative resources',
  precaution: 'These resources are general information, not a personal exercise, diet or medication plan. If you have a health condition, or are unsure what is suitable for you, ask your hospital team or GP before making changes.',
  alcoholNote: 'If you may be dependent on alcohol, do not stop drinking suddenly without medical advice. Alcohol withdrawal can be dangerous.',
  opensNewTab: 'Opens in a new tab',
});
export const WAITING_NATIONAL_RESOURCES = Object.freeze([
  {
    id: 'fitter-better-sooner',
    category: 'starting',
    title: 'Fitter Better Sooner',
    description: 'A practical patient toolkit on preparing your health before surgery.',
    provider: 'Centre for Perioperative Care',
    url: 'https://cpoc.org.uk/patients/fitter-better-sooner-toolkit',
  },
  {
    id: 'nhs-before-surgery',
    category: 'starting',
    title: 'Before your operation',
    description: 'What usually happens at preassessment and how to prepare for hospital.',
    provider: 'NHS',
    url: 'https://www.nhs.uk/tests-and-treatments/having-surgery/preparation/',
  },
  {
    id: 'my-planned-care',
    category: 'starting',
    title: 'My Planned Care',
    description: 'Official waiting-time information and services while you wait.',
    provider: 'NHS England',
    url: 'https://www.myplannedcare.nhs.uk/',
  },
  {
    id: 'physical-activity',
    category: 'topic',
    title: 'Moving and keeping active',
    description: 'Accessible NHS guidance, including different ways to be active.',
    provider: 'NHS',
    url: 'https://www.nhs.uk/live-well/exercise/',
  },
  {
    id: 'nutrition',
    category: 'topic',
    title: 'Eating well',
    description: 'Information about balanced nutrition and healthy eating.',
    provider: 'NHS',
    url: 'https://www.nhs.uk/live-well/eat-well/',
  },
  {
    id: 'smoking',
    category: 'topic',
    title: 'Support to stop smoking',
    description: 'Information about quitting and how to find help.',
    provider: 'NHS Better Health',
    url: 'https://www.nhs.uk/better-health/quit-smoking/ready-to-quit-smoking/',
  },
  {
    id: 'alcohol',
    category: 'topic',
    title: 'Alcohol advice and support',
    description: 'Information about alcohol and where to find support.',
    provider: 'NHS',
    url: 'https://www.nhs.uk/live-well/alcohol-advice/',
  },
  {
    id: 'wellbeing',
    category: 'topic',
    title: 'Looking after your mental wellbeing',
    description: 'Advice for managing worries, stress and uncertainty.',
    provider: 'NHS Every Mind Matters',
    url: 'https://www.nhs.uk/every-mind-matters/mental-wellbeing-tips/',
  },
  {
    id: 'sleep',
    category: 'topic',
    title: 'Sleeping better',
    description: 'Practical NHS information to support healthy sleep.',
    provider: 'NHS Every Mind Matters',
    url: 'https://www.nhs.uk/every-mind-matters/mental-wellbeing-tips/how-to-fall-asleep-faster-and-sleep-better/',
  },
]);

// Fixed escalation destination and visible labels used by the patient page.
export const WAITING_URGENT_HELP = Object.freeze({
  label: 'NHS 111',
  url: 'https://111.nhs.uk/',
  emergencyNumber: '999',
});
